import React, { useState } from "react";
import Sticky from "react-sticky-el";
import { scroller } from "react-scroll";
import InView from "react-intersection-observer";
import { products } from "./menu";
import HorizontalMenu from "./HorizontalMenu/";
import Separator from "../../components/Separator";
import {
  Banner,
  Container,
  CategorySelect,
  Controls,
  Figure,
  Group,
  Header,
  Image,
  Information,
  Input,
  Menu,
  Price,
  Product,
  Search,
  SearchIcon,
  Title,
  ProductSection,
} from "./styles";

const Products = () => {
  const [searchValue, setSearchValue] = useState("");
  const [selected, setSelected] = useState(53020);

  const filteredProducts = products.map((product) => {
    return {
      ...product,
      itens: product.itens.filter((item) =>
        item.name.toLowerCase().includes(searchValue.toLowerCase())
      ),
    };
  });

  const categories = products.map((item) => {
    return { value: item.id, label: item.name };
  });

  const selectOption = (categoryId, visible) => {
    if (visible) {
      setSelected(categoryId);
    }
  };

  const Select = () => (
    <CategorySelect
      defaultValue={categories.filter((cat) => cat.value === selected)}
      classNamePrefix="Select"
      options={categories}
      onChange={(element) => {
        if (element) {
          const value = element.value;
          scroller.scrollTo(value, {
            smooth: true,
            isDynamic: true,
            offset: -180,
          });
        }
      }}
    />
  );

  const Sec = ({ children, categoryId, selectOption }) => {
    return (
      <InView
        as="div"
        onChange={(inView, entry) => {
          selectOption(categoryId, inView);
        }}
        rootMargin="0px 0px -70%"
        trackVisibility={true}
        delay={100}
      >
        {children}
      </InView>
    );
  };

  return (
    <>
      <Banner>
        <h1> Produtos </h1>
      </Banner>
      <Container>
        <Sticky stickyStyle={{ top: "6rem" }}>
          <HorizontalMenu
            data={categories}
            selected={selected}
            scrollTo={(value) =>
              scroller.scrollTo(value, {
                smooth: true,
                isDynamic: true,
                offset: -120,
              })
            }
          />
        </Sticky>
        <Sticky stickyStyle={{ top: "10rem" }}>
          <Controls>
            <Select />
            <Search>
              <SearchIcon size="32" />
              <Input
                autoFocus
                placeholder="Buscar nos produtos"
                type="text"
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
              />
            </Search>
          </Controls>
        </Sticky>
        <Menu>
          {filteredProducts.map((category) =>
            category.itens.length !== 0 ? (
              <ProductSection>
                <Sec categoryId={category.id} selectOption={selectOption}>
                  <Header id={category.id}> {category.name} </Header>
                </Sec>
                <Group>
                  {category.itens.map((product) => {
                    return (
                      <Product>
                        <Information>
                          <div>
                            <Title> {product.name} </Title>
                            <p> {product.description}</p>
                          </div>
                          <Price> R$ {product.price}</Price>
                        </Information>
                        <Figure>
                          <Image src={product.image} />
                        </Figure>
                      </Product>
                    );
                  })}
                </Group>
              </ProductSection>
            ) : null
          )}
        </Menu>
      </Container>
      <Separator />
    </>
  );
};

export default Products;
